export default {
    setRolesList(state, data) {
        state.rolesList = data
    },
}
